import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { SummaryIcons } from '../icons/SummaryIcons';
import '../QueuePage.scss';
import HrbTranslate from '../../../components/language/HrbTranslate';


const ClearAllFilters = ({ onClick, textKey }) => {

    return (
        <div className='clear-all-filters-inner' onClick={onClick}>
            {SummaryIcons.CLEAR_ALL_FILTERS}
            <HrbTranslate text={textKey} />
        </div>
        )
}

ClearAllFilters.propTypes = {
    onClick: PropTypes.func
}

export default ClearAllFilters